module.exports = __webpack_public_path__ + "static/assets/129b99ac19024c35228d855f42fb852b.mp3";